import {appUrl} from "../helpers";

export function initGlobalProductSearch() {
  $('#global-product-search').kendoComboBox({
		placeholder: "Zboží ...",
		filter: "contains",
		autoBind: false,
    autoWidth: true,
    delay: 400,
    highlightFirst: false,
		minLength: 3,
		dataTextField: "name",
		dataValueField: "id",
		template: '<span class="k-state-default" style="background-image: url(\'#:data.image_path#\')"></span>'
			+ '<span class="k-state-default"><strong>#: data.name # <small>#: data.model_code #</small></strong><br /><em>#: data.stock_quantity #&nbsp;ks</em></span>',
		dataSource: {
			serverFiltering: true,
			transport: {
				read: {
					xhrFields: {
						withCredentials: true
					},
					url: appUrl('eshop') + '/product/product/search',
					dataType: "json"
				},
				cache: true
			}
		},
		select: function (e) {
      if (typeof e.dataItem === 'undefined') {
        return;
      }

      window.open(appUrl('eshop') + '/product/product/list#!detail-' + e.dataItem.id, '_blank')
		},
	});
}